import { useSnackbarStack } from '@superdispatch/ui';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateSearchQuery } from 'shared/utils/URLUtils';
import { PostingSavedSearchDTO } from '../../data/dto/PostingSavedSearchDTO';
import {
  convertPostingPageParamsToQuery,
  LoadSearchSource,
} from '../../data/dto/PostingsPageParamsDTO';
import { trackLoadboardEvent } from '../LoadboardAnalytics';

interface UseOpenAddSavedSearchPageProps {
  savedSearches: PostingSavedSearchDTO[] | undefined;
}
export function useOpenAddSavedSearchPage({
  savedSearches,
}: UseOpenAddSavedSearchPageProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { addSnackbar } = useSnackbarStack();

  return useCallback(
    (source: LoadSearchSource) => {
      if (savedSearches && savedSearches.length >= 50) {
        addSnackbar('Exceeded Load Alert Limit of 50', { variant: 'error' });
      } else {
        navigate({
          pathname: '/filter',
          search: updateSearchQuery(location.search, () =>
            convertPostingPageParamsToQuery({
              utm_medium: source,
              load_alert: 'create',
            }),
          ),
        });
        trackLoadboardEvent({ name: 'SLB: Clicked Create Load Alert', source });
      }
    },
    [navigate, addSnackbar, location, savedSearches],
  );
}
